import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FiX , FiMenu } from "react-icons/fi";
import Avatar from 'react-avatar';

import { isUserAuthenticated, getLoggedInUser } from '../../helpers/authUtils';

class Header extends Component{

    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.state = {user: getLoggedInUser()}
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }
    render(){
        const { user } = this.state;

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        
        const { color , headerPosition } = this.props;
        let logoUrl = <img src="/assets/images/logo/logo.png" alt="EEVS Alumni" />;
        
        return(
            <header className={`header-area formobile-menu ${headerPosition} ${color}`}>
                <div className="header-wrapper" id="header-wrapper">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-4 col-6">
                                <div className="header-left">
                                    <div className="logo">
                                        <a href="/">
                                            {logoUrl}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-8 col-6">
                                <div className="header-right justify-content-end">
                                    <nav className="mainmenunav d-lg-block">
                                        <ul className="mainmenu" style={{alignItems: 'center'}}>
                                            <li><Link to="/">HOME</Link></li>
                                            <li><Link to="/about" >ABOUT</Link></li>
                                            <li><Link to="/news" >NEWS</Link></li>
                                            <li><Link to="/partners" >PARTNERS</Link></li>
                                            <li><Link to="/deals" >DEALS</Link></li>
                                            <li><Link to="/faqs" >FAQs</Link></li>
                                            <li><Link to="/contact" >CONTACT</Link></li>
                                            {
                                                !isUserAuthenticated() ? (
                                                    <li><Link to="/login" >LOG IN</Link></li>
                                                ): (
                                                <li  className="has-droupdown"><Link to="#" >
                                                    <Avatar style={{marginRight: 10}} name={`${user.firstName} ${user.lastName}`} size={40} round={true} />
                                                    {user.firstName} {user.lastName}</Link>
                                                        <ul className="submenu">
                                                            <li><Link to="/dashboard">Dashboard</Link></li>
                                                            <li><Link to="/refer-a-friend">Refer a friend</Link></li>
                                                            <li><Link to="/update-profile">Update Profile</Link></li>
                                                            <li><Link to="/change-password">Change Password</Link></li>
                                                            <li><Link to="/logout">Logout</Link></li>
                                                        </ul>
                                                    </li>
                                                )
                                            }
                                            
                                        </ul>
                                    </nav>
                                    {
                                        !isUserAuthenticated() && (
                                            <div className="header-btn">
                                                <a className="rn-btn" href="/join-now">
                                                    <span>JOIN NOW</span>
                                                </a>
                                            </div>
                                        )
                                    }
                                    
                                    {/* Start Humberger Menu  */}
                                    <div className="humberger-menu d-block d-lg-none pl--20">
                                        <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                                    </div>
                                    {/* End Humberger Menu  */}
                                    <div className="close-menu d-block d-lg-none">
                                        <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;